export default [
  { key: 'stairs', label: 'Stairs' },
  { key: 'elevator', label: 'Elevator' },
  { key: 'ground_floor', label: 'Ground Floor' },
  { key: 'freight_elevator', label: 'Freight Elevator' }
];
